import { ChangeEventHandler } from 'react';
import * as React from 'react';

/* eslint-disable react/prop-types */
import { translate } from '~l10n/client';

import { useRoomsList } from '~teacher/hook/room';
import { useMaxRosterSize } from '~teacher/hook/room/useMaxRosterSize';

import Anchor from '../../../../shared/components/elements/Anchor';
import Input from '../../../../shared/components/elements/Input';
import Loader from '../../../../shared/components/status/Loader';
import ImportRosterMessage from '../components/ImportRosterMessage';

const Constants = require('Constants');

export default function SelectNewStudentsView({
  controller,
  loader,
  studentsInRoom,
  name,
  roomId,
}: {
  loader: any;
  controller: any;
  studentsInRoom: boolean;
  name: string;
  roomId: number;
}) {
  const [newStudents, setNewStudents] = React.useState('');

  const c = controller;

  const maxStudentsInRoom = useMaxRosterSize();
  const studentInRoomCount = useRoomsList({
    select: (rooms) => {
      const room = rooms.find((room) => room.id === roomId);
      return room?.studentCount ?? 0;
    },
  });

  if (loader || maxStudentsInRoom.isLoading || studentInRoomCount.isLoading) {
    return (
      <div className="add-students-container">
        <Loader />
      </div>
    );
  }

  const maxStudentsLimitPerRoom = maxStudentsInRoom.data ?? 0;
  const maxStudents = maxStudentsLimitPerRoom - (studentInRoomCount.data ?? 0);

  const isInRange =
    0 < Number(newStudents) && Number(newStudents) <= maxStudents;

  const onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const value = event.target.value;

    setNewStudents(value);
  };

  const handleSelectNewClicked = () =>
    c.selectedNewClicked(newStudents, roomId);

  return (
    <div className="add-students-container form">
      {studentsInRoom ? <ImportRosterMessage name={name} /> : null}
      <p
        style={{
          marginTop: studentsInRoom ? '20px' : '0',
        }}
      >
        {translate('How many students would you like to add?')}
      </p>
      <div className="add-students-form">
        <Input
          autoFocus={true}
          type="tel"
          value={newStudents}
          onChange={onChange}
        />
        <div className="button-container">
          <button
            className="button-secondary button-large button"
            disabled={!isInRange}
            type="button"
            onClick={handleSelectNewClicked}
          >
            {translate('Create Form')}
          </button>
        </div>
      </div>
      <span className="max-students-info">
        {translate('Add up to {0} students.').format(maxStudentsLimitPerRoom)}{' '}
        {maxStudentsLimitPerRoom < Constants.MAX_PRO_ROSTERED_STUDENTS ? (
          <Anchor
            label={translate('Need more?')}
            href="#pricing"
            onClick={() => {
              c.closePopup();
            }}
          />
        ) : null}
      </span>
    </div>
  );
}
